export default "__VITE_ASSET__d901002c__"